export const CURRENCY = {
  India: {
    sym: '₹',
    code: 'INR',
    format: (n, formatNum) => '₹' + formatNum(n),
  },
  USA: {
    sym: '$',
    code: 'USD',
    format: (n, formatNum) => '$' + formatNum(n),
  },
  UK: {
    sym: '£',
    code: 'GBP',
    format: (n, formatNum) => '£' + formatNum(n),
  },
  Europe: {
    sym: '€',
    code: 'EUR',
    format: (n, formatNum) => '€' + formatNum(n),
  },
  Australia: {
    sym: 'A$',
    code: 'AUD',
    format: (n, formatNum) => 'A$' + formatNum(n),
  },
  UAE: {
    sym: 'AED',
    code: 'AED',
    format: (n, formatNum) => 'AED ' + formatNum(n),
  },
  Canada: {
    sym: 'C$',
    code: 'CAD',
    format: (n, formatNum) => 'C$' + formatNum(n),
  },
}

export const FORMAT_PILLS = [
  'Short Film',
  'Feature Film',
  'Web Series',
  'OTT Original',
  'Documentary',
  'Ad Film / TVC',
  'Music Video',
  'Stage Play',
  'TV Show / Soap',
  'Reality Show',
  'Corporate Film',
  'Animation',
  'Podcast / Audio',
]

export { SECTION_COLORS } from '../productionTools/themeColors'

export const SECTION_LABELS = {
  atl: 'Above the Line',
  btl: 'Below the Line',
  post: 'Post Production',
  other: 'Other / Fringes',
}

export const STREAM_MESSAGES = [
  'Reading project inputs...',
  'Calculating ATL / BTL split...',
  'Allocating line items...',
  'Checking budget health ratios...',
  'Generating AI commentary...',
  'Finalizing breakdown...',
]
